import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import Signup from "../pages/auth/Signup";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import VerifyEmail from "../pages/auth/VerifyEmail";
import Logout from "../pages/auth/Logout";
import Dashboard from "../pages/Dashboard";
import CreateAuth from "../pages/CreateAuth";
import LoadAmountPage from "../pages/LoadAmountPage";
import CompanyBalancePage from "../pages/CompanyBalancePage";
import CompanyTransactions from "../pages/CompanyTransactions";
import CompanyUserPoints from "../pages/CompanyUserPoints";
import UserPointsLedger from "../pages/UserPointsLedger";
import ChangePassword from "../pages/auth/ChangePassword";

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '',
                element: <Login />
            },
            {
                path: 'signup',
                element: <Signup />
            },
            {
                path: 'login',
                element: <Login />
            },
            {
                path: 'forgot-password',
                element: <ForgotPassword />
            },
            {
                path: 'verify-email',
                element: <VerifyEmail />
            },
            {
                path: 'logout',
                element: <Logout />
            },
            {
                path: 'dashboard',
                element: <Dashboard/>, // Placeholder for dashboard
                children:[
                    {
                        path:"load-amount",
                        element:<LoadAmountPage/>
                    },
                    {
                        path:"company-balance",
                        element:<CompanyBalancePage/>
                    },
                    {
                        path:"company-dashboard",
                        element:<CompanyTransactions/>
                    },
                    {
                        path:"user-points",
                        element:<CompanyUserPoints/>
                    },
                    {
                        path:"user-points-ledger",
                        element:<UserPointsLedger/>
                    },
                    {
                        path:"change-password",
                        element:<ChangePassword/>
                    }
                ]
            },
            {
                path:'create-auth',
                element:<CreateAuth/>
            }
        ]
    }
]);

export default router;